
import { throwError as observableThrowError, empty as observableEmpty, Observable } from 'rxjs';

import { retryWhen, scan, delay, catchError } from 'rxjs/operators';
import { Injectable, EventEmitter } from '@angular/core';
import {
    HttpModule, Http, RequestOptions, Response, Headers, Request, RequestOptionsArgs, XHRBackend,
    ConnectionBackend
} from '@angular/http';
import { Router } from '@angular/router';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';



import { Message } from 'primeng/primeng';
import { SharedService } from '../shared/shared.service';
import { CommunicationService } from '../shared/communication.service';
import { AuthService } from '../../authentication/auth.service';

@Injectable()
export class HttpInterceptor extends Http {

    // notification: EventEmitter<Message> = new EventEmitter();
    private ac_token: string = null;

    constructor(backend: ConnectionBackend, defaultOptions: RequestOptions,
        private _router: Router, private communicationService: CommunicationService,
        private authService: AuthService) {
        super(backend, defaultOptions);
    }

    request(url: string | Request, options?: RequestOptionsArgs): Observable<Response> {
        return this.intercept(super.request(url, options));
    }

    get(url: string, options?: RequestOptionsArgs): Observable<Response> {
        return this.intercept(super.get(url, this.getRequestOptionArgs(options)).pipe(
            retryWhen(err => err.pipe(
                scan((acc, err) => {
                    if (acc >= 1) throw err;
                    console.log("Retrying... Attempt#" + (+acc + 1));
                    return acc = acc + 1;
                }, 0)//scan
                , delay(1000)
            ) //pipe
            ))//retry ends  
        )
    }

    post(url: string, body: string, options?: RequestOptionsArgs): Observable<Response> {
        return this.intercept(super.post(url, body, this.getRequestOptionArgs(options)));
    }

    put(url: string, body: string, options?: RequestOptionsArgs): Observable<Response> {
        return this.intercept(super.put(url, body, this.getRequestOptionArgs(options)));
    }

    delete(url: string, options?: RequestOptionsArgs): Observable<Response> {
        return this.intercept(super.delete(url, this.getRequestOptionArgs(options)));
    }

    getRequestOptionArgs(options?: RequestOptionsArgs): RequestOptionsArgs {
        
        if (options == null) {
            options = new RequestOptions();
        }
        if (options.headers == null) {
            options.headers = new Headers();
            options.headers.append('Content-Type', 'application/json');
        }


        options.headers.append('Pragma', 'no-cache');
        // var ac_token = localStorage.getItem('authorizationData');
        if (this.authService.isLoggedIn) {
            try { this.ac_token = this.authService.getAuthorizationHeaderValue(); } catch (e) { }
        }
        else {
            // this.authService.signOut();
            //this.communicationService.alertMessage({ severity: 'info', summary: 'Logout', detail: 'Session expired. You will be redirected to Login page.' });
        }
        //options.headers.append('Authorization', 'Bearer ' + ac_token);
        options.headers.append('Authorization', this.ac_token);
        return options;
    }

    intercept(observable: Observable<Response>): Observable<Response> {
        return observable.pipe(
            catchError((err, source) => {
                console.log(err);
                console.log(source);
                console.log('BROWSER-UI:HTTP:EXCEPTION');
                if (err.status == 401) {
                    if (this.ac_token) {
                        this.authService.signOut(true);
                        this.communicationService.alertMessage({ severity: 'info', summary: 'Logout', detail: 'Session expired. You will be redirected to Login page.' });
                    }
                    //else
                        //this.authService.startAuthentication();
                    return observableEmpty();
                }
                else if (err.status == 403)
                    this.communicationService.alertMessage({ severity: 'warn', summary: 'Unauthorized', detail: err.statusText });
                else if (err && err.statusText)
                    this.communicationService.alertMessage({ severity: 'error', summary: 'Unexpected error', detail: err.statusText });
                return observableThrowError(err);
            }));
    } //intercept
    // handleError<T>(operation = 'operation', result?: T) {
    //     return (error: any): Observable<T> => {
    //         // TODO: send the error to remote logging infrastructure
    //         console.error(error); // log to console instead
    //         // TODO: better job of transforming error for user consumption
    //         //this.log(`${operation} failed: ${error.message}`);
    //         // Let the app keep running by returning an empty result.
    //         return of(result as T);
    //     };
    // }
}

